import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./Translations/LenguageContext";

import "./App.css";
import "./AppMobile.css";
import "./PlatformLoaders.css";

import ScrollToTop from "./Functions/ScrollToTop";

import Register from "./Authentication/Register";
import Login from "./Authentication/Login";
import LoginPcPage from "./Authentication/LoginPCPage";
import Terms_And_Conditions from "./Policies/TermsConditions";
import Cookie_Policy from "./Policies/CookiesPolicy";
import Legal_Notes from "./Policies/LegalNotes";
import Privacy_Policy from "./Policies/PrivacyPolicy";
import MainFramdeAdmin from "./AdminPlatform/MainFrameAdmin";
import AcceptInvitation from "./Authentication/AcceptInvitation";
import VerifyEmail from "./Authentication/VerifyEmail";
import EmailVerified from "./Authentication/EmailVerified";
import MainOnboarding from "./Onboarding/MainOnboarding";

const RedirectToHome = () => {
  window.location.replace("https://www.abstracht.com/");
  return null;
};

const AppRoutes = () => (

  <Routes>
    <Route
      path="/"
      element={
        <RedirectToHome />
      }
    />    
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/mobile_device" element={<LoginPcPage />} />
    <Route path="/verify-email" element={<VerifyEmail />} />
    <Route path="/email-verify" element={<EmailVerified />} />
    <Route path="/onboarding/:onb_step" element={<MainOnboarding />} />

    {/* Policies */}
    <Route path="/privacy" element={<Privacy_Policy />} />
    <Route path="/terms-and-conditions" element={<Terms_And_Conditions />} />
    <Route path="/cookie-policy" element={<Cookie_Policy />} />
    <Route path="/legal-notes" element={<Legal_Notes />} />

    {/* Invitation */}
    <Route path="/accept-invitation" element={<AcceptInvitation />} />

    {/* Platform */}
    <Route path="/console/*" element={<MainFramdeAdmin />} />


  </Routes>
);

const ThemeController = () => {
  const location = useLocation();
  const [audioEnabled, setAudioEnabled] = useState(false);

  const unlockAudio = () => {
    if (audioEnabled) return;

    const audio = new Audio("/sound/click_sound.mp3");
    audio.volume = 0;

    audio.play()
      .then(() => setAudioEnabled(true))
      .catch(() => { });
  };


  useEffect(() => {
    unlockAudio()
    const root = window.document.documentElement;

    const isPlatform =
      location.pathname.startsWith("/console") ||
      location.pathname.startsWith("/google-callback") ||
      location.pathname.startsWith("/outlook-callback") ||
      location.pathname.startsWith("/onboarding") ||
      location.pathname.startsWith("/directories")

    root.removeAttribute("data-theme");

    if (!isPlatform) {
      root.setAttribute("data-theme", "light");
      return;
    }

    const applyTheme = () => {
      const savedTheme = localStorage.getItem("absttheme-preference");

      let themeToSet = savedTheme;

      if (!savedTheme || savedTheme === "system") {
        themeToSet = window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";
      }

      root.setAttribute("data-theme", themeToSet);
    };

    applyTheme();

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleSystemChange = () => {
      const currentPref = localStorage.getItem("absttheme-preference");
      if (!currentPref || currentPref === "system") {
        applyTheme();
      }
    };

    mediaQuery.addEventListener("change", handleSystemChange);
    window.addEventListener("storage", applyTheme);

    return () => {
      mediaQuery.removeEventListener("change", handleSystemChange);
      window.removeEventListener("storage", applyTheme);
    };
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <ThemeController />
        <ScrollToTop />
        <AppRoutes />
      </Router>
    </LanguageProvider>
  );
};

export default App;